import { PapiUser } from '@wix/da-papi-types';

export const reduxKey = '@@DAMZ';
export const drawerStreamId = `${reduxKey}:drawer:`;
export const roomStreamIdPrefix = `${reduxKey}:room:`;
export const roomStreamGroupId = 'damzMessages';
export const roomItemStreamGroupId = 'damzRoomItems';
export const messageSearchStreamId = `${reduxKey}:messageSearch`;
export const activityUpdateFrequencyMs = 1000;
export const STREAM_WINDOW_SIZE_DESKTOP = 500;
export const STREAM_WINDOW_SIZE_MOBILE = 200;
export const maximumAttachments = 6;
export const TEMP_DRAFT_ROOM_ID = 'temp1';
export const maximumMultiroomParticipants = 20;
export const editMessageWindow = 15; // minutes
export const MAX_ROOM_NAME_LENGTH = 50;
export const MAX_USERS_COMMUNITY_CHANNEL_CORE = 50;
export const MAX_USERS_PER_ROOM_DEFAULT = 20;
export const FETCH_LIMIT_MESSAGES_AROUND = 9;
export const FETCH_LIMIT_MESSAGES_DEFAULT = 30;
export const MESSAGE_SEARCH_MAX_RESULTS = 1000;
// Users you can't chat with
export const NON_CHAT_USERS: PapiUser[] = [
  {
    userId: 93413,
    username: 'devart',
    type: 'user',
    isNewDeviant: false,
    usericon: '',
    useridUuid: '',
  },
  {
    userId: 47880507,
    username: 'team',
    type: 'user',
    isNewDeviant: false,
    usericon: '',
    useridUuid: '',
  },
];
